import { TRightId } from 'lib/api';
import { observer } from 'mobx-react-lite';
import { useRightStore } from 'src/context';
import { AddNewButton } from '../AddNewButton';
import { BulkDeleteButton } from '../BulkDeleteButton';
import { SaveStatus } from '../SaveStatusIndicator';
import { PageHeader } from '../PageHeader';

export type LicensingRightsHeaderProps = {
  onCreate: () => void;
  onUpload: () => void;
  onDelete: () => void;
  selected: TRightId[];
};

export const LicensingRightsHeader = observer(
  ({ onCreate, onUpload, onDelete, selected }: LicensingRightsHeaderProps) => {
    /** Context **/
    const rightStore = useRightStore();

    /** Computed **/
    const saveStatus = rightStore.isSaving ? SaveStatus.Saving : SaveStatus.Saved;

    /** Render **/
    return (
      <PageHeader
        title="Licensing & Rights"
        saveStatus={saveStatus}
        actions={
          <>
            <BulkDeleteButton
              count={selected.length}
              singular="right"
              plural="rights"
              onDelete={onDelete}
              confirm={false}
            />
            <AddNewButton
              secondary
              onClick={onUpload}
              label="Upload document"
              tipText="Upload License/Rights Document"
            />
            <AddNewButton onClick={onCreate} label="New right" tipText="New Licensing & Rights" />
          </>
        }
      />
    );
  }
);
